import {APIMethod, fetchData} from "@client";

export async function getCompanyMcpSsoAccessQuery() {
    const response = await fetchData("/company/mcp-sso/users");
    return response.members || [];
}

export async function getOwnMcpSsoStatusQuery() {
    const response = await fetchData("/company/mcp-sso/me");
    return response.access || {accessLevel: "none", status: "revoked"};
}

export async function changeCompanyMcpSsoAccessQuery(userUuid, accessLevel) {
    const response = await fetchData(
        `/company/mcp-sso/users/${encodeURIComponent(userUuid)}`,
        APIMethod.PUT,
        {
            data: {access_level: accessLevel},
            isJSONData: true,
        },
    );
    return response.access;
}

export async function startMcpSsoLinkQuery(provider) {
    const response = await fetchData(
        "/company/mcp-sso/link/start",
        APIMethod.POST,
        {
            data: {provider},
            isJSONData: true,
        },
    );

    return {
        authorizationUrl: response.authorizationUrl || response.authorization_url,
    };
}

export async function completeMcpSsoLinkQuery(state, code) {
    const response = await fetchData(
        "/company/mcp-sso/link/callback",
        APIMethod.POST,
        {
            data: {state, code},
            isJSONData: true,
        },
    );
    return response.access;
}

export async function retryCompanyMcpSsoAccessQuery(userUuid) {
    const response = await fetchData(
        `/company/mcp-sso/users/${encodeURIComponent(userUuid)}/retry`,
        APIMethod.POST,
    );
    return response.access;
}

export async function resetCompanyMcpSsoIdentityQuery(userUuid, confirmation) {
    const response = await fetchData(
        `/company/mcp-sso/users/${encodeURIComponent(userUuid)}/reset`,
        APIMethod.POST,
        {
            data: {confirmation},
            isJSONData: true,
        },
    );
    return response.access;
}

export async function resendCompanyMcpSsoLinkEmailQuery(userUuid) {
    return fetchData(
        `/company/mcp-sso/users/${encodeURIComponent(userUuid)}/resend`,
        APIMethod.POST,
    );
}
